// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

function getFill(style) {
  switch (style) {
    case 1 :
        return "#b4702d";
    case 2 :
        return "#b7bdbe";
    case 3 :
        return "#d0b30b";
    case 4 :
        return "#b39ddb";
    default:
      return "magenta";
  }
}

function TraitTeam2(Props) {
  var traits = Props.traits;
  var chosenTraitsOpt = Props.chosenTraits;
  var classNameOpt = Props.className;
  var chosenTraits = chosenTraitsOpt !== undefined ? chosenTraitsOpt : [];
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var set = TftSet.use(undefined);
  var basePath = CdnAtom.usePath5(undefined);
  var traits$1 = traits.length > 9 ? Belt_Array.keep(traits, (function (param) {
            return !Sd.isTraitUnique(param[0], set);
          })) : traits;
  var width = 24 + Math.imul(traits$1.length - 1 | 0, 12) | 0;
  return React.createElement("svg", {
              className: className,
              height: "46",
              width: "120",
              viewBox: String((width - 120 | 0) / 2 | 0) + " 0 120 46"
            }, Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(traits$1, (function (param, param$1) {
                        return -Caml.caml_int_compare(Sd.traitStyle(param[0], param[1], set), Sd.traitStyle(param$1[0], param$1[1], set)) | 0;
                      })), (function (i, param) {
                    var rank = param[1];
                    var traitId = param[0];
                    var style = Sd.traitStyle(traitId, rank, set);
                    var x = 1 + Math.imul(i, 12) | 0;
                    var href = traitId.includes("Teamup") ? basePath + "/img/traits2/" + traitId + "_" + String(style) + ".png?w=17" : basePath + "/static/trait-icons/" + traitId + "_" + String(style) + ".svg";
                    var match = i % 2;
                    var y;
                    if (match !== 0) {
                      if (match !== 1) {
                        throw {
                              RE_EXN_ID: "Assert_failure",
                              _1: [
                                "TraitTeam2.res",
                                42,
                                13
                              ],
                              Error: new Error()
                            };
                      }
                      y = 21;
                    } else {
                      y = 1;
                    }
                    return React.createElement(React.Fragment, {
                                children: null,
                                key: traitId
                              }, React.createElement("image", {
                                    height: "17",
                                    href: href,
                                    width: "17",
                                    transform: "translate(" + String(x) + ", " + String(y) + ")",
                                    x: "2",
                                    y: "3.5"
                                  }), React.createElement(TraitTooltip.make, {
                                    trait: traitId,
                                    rank: rank,
                                    children: React.createElement("path", {
                                          d: T.genHexPath(12),
                                          fill: getFill(style) + "22",
                                          stroke: getFill(style) + "cc",
                                          strokeWidth: "1.5",
                                          transform: "translate(" + String(x) + ", " + String(y) + ")"
                                        }),
                                    key: traitId
                                  }), chosenTraits.includes(traitId) ? React.createElement("image", {
                                      height: "12",
                                      href: basePath + "/img/general/headliner.png?w=12",
                                      width: "12",
                                      transform: "translate(" + String(x) + ", " + String(y) + ")",
                                      x: "8",
                                      y: "13"
                                    }) : null);
                  })));
}

var make = TraitTeam2;

export {
  getFill ,
  make ,
  
}
/* T Not a pure module */
